import * as app from './scripts/Core/App';
import Hotjar from './scripts/Modules/Hotjar';
import ProximosEstrenosTeatroFilter from './scripts/Modules/Filters/ProximosEstrenosTeatroFilter';
import Analytics from './scripts/Modules/Analytics';

app.start().then(() => {
    const hotjar = new Hotjar();
    hotjar.tagRecording('proximos-estrenos-teatro');

    // Configuracion de filtros
    const filters = new ProximosEstrenosTeatroFilter({
        source: $('#lista-obras article'),
        month: $('#filtro-month-obra'),
        genero: $('#filtro-genero-obra')
    });


    const InitFilter = () => {
        filters.month.change(function () {
            applyFilter();
            Analytics.trackEvent('Proximos Estrenos Teatro', 'Uso de filtros', 'Seleccionar mes');
        });
        filters.genero.change(function () {
            
            applyFilter();
            Analytics.trackEvent('Proximos Estrenos Teatro', 'Uso de filtros', 'Seleccionar genero');
        });
    };

    const applyFilter = () => {
        filters.fillSearch();
    };

    InitFilter();
});


// WEBPACK FOOTER //
// ./Statics/ProximosEstrenosTeatro.js